import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    .light{
        --live-primary-blue_600:  #1097d0;
        --alert-dashboard-blue_900: #ebfeff;
    }

    .dark{
        --live-primary-blue_600:  #12AAEB;
        --alert-dashboard-blue_900: var(--beam-color-teal_900);
    }
        
    .w-100 {
        width: 100%;
    }

    .h-100 {
        height: 100%;
    }

    .flex {
        display: flex;
    }

    .flex-1 {
        flex: 1;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .flex-row-reverse {
        display: flex;
        flex-direction: row-reverse;
    }

    .flex-column-reverse {
        display: flex;
        flex-direction: column-reverse;
    }

    .align-center {
        align-items: center;
    }

    .align-end {
        align-items: end;
    }

    .align-start {
        align-items: start;
    }

    .align-baseline {
        align-items: baseline;
    }

    .justify-center {
        justify-content:center;
    }

    .justify-start{
        justify-content: flex-start;
    }

    .justify-end{
        justify-content: flex-end;
    }

    .justify-between{
        justify-content: space-between;
    }

    .flex-wrap {
        flex-wrap: wrap;
    }


    .gap-1{
        gap:4px;
    }

    .gap-2{
        gap:8px;
    }

    .gap-3{
        gap:12px;
    }
    
    .gap-4{
        gap:16px;
    }

    .p-1{
        padding: 4px;
    }

    .p-2{
        padding: 8px;
    }

    .p-3{
        padding: 12px;
    }

    .p-4{
        padding: 16px;
    }

    .cursor-p {
        cursor:pointer;
    }

    .capitalize {
        text-transform: capitalize;
    }

    .text-overflow {
        display: inline-block !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* [hidden]{
        display:none !important;
        visibility: hidden;
    } */

    .overflow-y {
        overflow-y: auto;
    }
    
    .custom-scrollbar {
        @supports selector(::-webkit-scrollbar) {
            &::-webkit-scrollbar  {
                width: 8px;
                height: 8px;
            }

            &::-webkit-scrollbar-track {
                background: transparent;
                border-radius: 8px;
                margin: 1px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 8px;
                background-clip: padding-box;
                background-color: var(--beam-color-gray_300);
            }
        }            
    }    

    .hover-scrollbar {
        @supports selector(::-webkit-scrollbar) {
            &::-webkit-scrollbar-thumb {
                background: transparent;
            }
            
            &:hover {
                &::-webkit-scrollbar-thumb {
                    background: var(--beam-color-gray_300);
                }
            }
        }
    }   

    // Custom disabled button
    .btn-custom-disabled.beam-btn:disabled{
        background: var(--beam-surface--secondary);
        box-shadow: unset;
        color: inherit;
    }

    // overwrite Beam Switch bg color
    .beam-switch input:checked + label:before {
        background-color: var(--live-primary-blue_600);
    }

    // TODO check all input states
    // overwrite Beam input active/focus border color
    .beam-text-field__inner:focus-within,
    // overwrite Beam textarea active/focus border color
    .beam-textarea__input-wrapper textarea:focus, 
    // overwrite Beam select active/focus border color
    .beam-native-select__selector:focus-within .beam-native-select__fieldset-frame {
        box-shadow: 0 0 0 1px var(--live-primary-blue_600) inset !important;
    }

    .beam-btn--primary {
        background-color: var(--live-primary-blue_600);
    }

    @keyframes breath-animation {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }    
`
